import settings from '../data/settings.json'

export async function getSettings() {
	return {
		success: true,
		data: settings
	}
}
